// Member discount campaign, auto-applied at checkout for logged-in users.
// Must match backend/config/memberCampaign.js and the campaign document in the DB.
export const MEMBER_CAMPAIGN_CODE = 'UYEINDIRIMI';
export const MEMBER_DISCOUNT_PERCENT = 20;
